/**
 * Whether to show the Daily Puzzle link in the site header (desktop + mobile).
 *
 * Opt-in: set `NEXT_PUBLIC_SHOW_DAILY_PUZZLE_NAV` to `true`, `1`, or `yes` to show.
 * When unset or any other value, the link is hidden.
 */
export function parseShowDailyPuzzleNavLink(value: string | undefined): boolean {
  const v = value?.toLowerCase().trim();
  return v === "true" || v === "1" || v === "yes";
}

/** Inlined at build time for client components. */
export const showDailyPuzzleNavLink = parseShowDailyPuzzleNavLink(
  process.env.NEXT_PUBLIC_SHOW_DAILY_PUZZLE_NAV
);
